export const selectEventDetails = (state) => state.eventDetails;
